"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPropertyExtraFilled = function IconPropertyExtraFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.5 19H41V15.5C41 15.1022 40.842 14.7206 40.5607 14.4393C40.2794 14.158 39.8978 14 39.5 14C39.1022 14 38.7206 14.158 38.4393 14.4393C38.158 14.7206 38 15.1022 38 15.5V19H34.5C34.1022 19 33.7206 19.158 33.4393 19.4393C33.158 19.7206 33 20.1022 33 20.5C33 20.8978 33.158 21.2794 33.4393 21.5607C33.7206 21.842 34.1022 22 34.5 22H38V25.5C38 25.8978 38.158 26.2794 38.4393 26.5607C38.7206 26.842 39.1022 27 39.5 27C39.8978 27 40.2794 26.842 40.5607 26.5607C40.842 26.2794 41 25.8978 41 25.5V22H44.5C44.8978 22 45.2794 21.842 45.5607 21.5607C45.842 21.2794 46 20.8978 46 20.5C46 20.1022 45.842 19.7206 45.5607 19.4393C45.2794 19.158 44.8978 19 44.5 19Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.5 29C38.5718 29 37.6815 28.6313 37.0251 27.9749C36.3688 27.3185 36 26.4283 36 25.5V24H34.5C33.5718 24 32.6815 23.6313 32.0251 22.9749C31.3688 22.3185 31 21.4283 31 20.5C31 19.5717 31.3688 18.6815 32.0251 18.0251C32.6815 17.3688 33.5718 17 34.5 17H36V10.81C36 10.5448 35.8947 10.2904 35.7071 10.1029C35.5196 9.91536 35.2652 9.81 35 9.81H31C30.7348 9.81 30.4804 9.91536 30.2929 10.1029C30.1054 10.2904 30 10.5448 30 10.81V12.15L25.55 9.15C25.3867 9.04248 25.1955 8.98517 25 8.98517C24.8045 8.98517 24.6133 9.04248 24.45 9.15L10.45 18.54C10.311 18.6315 10.1971 18.7563 10.1185 18.903C10.0399 19.0496 9.99921 19.2136 10 19.38V40C10 40.2652 10.1054 40.5196 10.2929 40.7071C10.4804 40.8946 10.7348 41 11 41H17V31C17 30.7348 17.1054 30.4804 17.2929 30.2929C17.4804 30.1054 17.7348 30 18 30H23C23.2652 30 23.5196 30.1054 23.7071 30.2929C23.8947 30.4804 24 30.7348 24 31V41H39C39.2652 41 39.5196 40.8946 39.7071 40.7071C39.8947 40.5196 40 40.2652 40 40V29C39.8337 29.0152 39.6663 29.0152 39.5 29Z",
    fill: color
  }));
};

IconPropertyExtraFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconPropertyExtraFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconPropertyExtraFilled;
exports.default = _default;